export default function SidebarFooter() {
  return (
    <div className="shrink-0 px-4 py-3 text-center text-[11px] text-gray-400 border-t border-gray-100 bg-gray-50">
      <span>&copy; 2025 РУДН &bull; Навигация по кампусу</span>
    </div>
  );
}
